import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'aw-test-dialog-info',
  templateUrl: './test-dialog-info.component.html',
  styleUrls: ['./test-dialog-info.component.scss']
})
export class TestDialogInfoComponent implements OnInit {

  output = null;

  constructor(
    public dialogRef: MatDialogRef<TestDialogInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}


  ngOnInit(): void {
    this.output = JSON.stringify(this.data, undefined, 2);
  }
  
  
}
